/**
 * ACF Block - Timeline
 *
 * Script per il blocco acf/timeline.
 * Gestisce l'inizializzazione e le interazioni della timeline.
 *
 * @package Celada
 */

import '../../scss/acf-blocks/acfb-timeline.scss';

document.addEventListener('DOMContentLoaded', function () {
	const navItems = document.querySelectorAll('.timeline-nav__item');
	if (!navItems.length) return;

	const header = document.querySelector('.site-header');

	const nav = navItems[0].closest('.timeline-nav');
	if ( !nav ) return;

	// Inserisce puntini separatori tra gli item come flex children
	Array.from(navItems).slice(0, -1).forEach(function (item) {
		const dot = document.createElement('span');
		dot.className = 'timeline-nav__dot';
		dot.setAttribute('aria-hidden', 'true');
		item.after(dot);
	});

	// Scroll al click
	navItems.forEach(function (item) {
		item.addEventListener('click', function (e) {
			e.preventDefault();

			const targetId = item.getAttribute('data-target');
			const target = document.getElementById(targetId);
			if (!target) return;

			const offset = header ? header.offsetHeight : 0;
			const top = target.getBoundingClientRect().top + window.scrollY - offset;

			window.scrollTo({ top, behavior: 'smooth' });
		});
	});

	// Evidenzia la voce attiva durante lo scroll
	const targets = Array.from(navItems).map(function (item) {
		return document.getElementById(item.getAttribute('data-target'));
	});

	// Connettori tra elementi
	const connectors = document.querySelectorAll('.timeline-element__spacer[data-connector]');

	let lastActiveIndex = -1; // eslint-disable-line no-unused-vars

	function setActive() {
		const offset = (header ? header.offsetHeight : 0) + 32;
		let activeIndex = 0;

		targets.forEach(function (el, i) {
			if (el && el.getBoundingClientRect().top - offset <= 0) {
				activeIndex = i;
			}
		});

		navItems.forEach(function (item, i) {
			item.classList.toggle('is-active', i === activeIndex);
			item.classList.toggle('is-passed', i < activeIndex);
		});

		// Scroll orizzontale del nav proporzionale allo scroll verticale nella timeline
		const first = targets[0];
		const last  = targets[targets.length - 1];
		if (first && last) {
			const start    = first.getBoundingClientRect().top + window.scrollY - offset;
			const end      = last.getBoundingClientRect().top  + window.scrollY - offset;
			const progress = Math.min(1, Math.max(0, (window.scrollY - start) / (end - start)));
			const maxScroll = nav.scrollWidth - nav.clientWidth;
			nav.scrollLeft = progress * maxScroll;
		}

		// Aggiorna fill connettori tra elementi
		connectors.forEach(function (connector) {
			const idx = parseInt(connector.getAttribute('data-connector'), 10) - 1;
			const from = targets[idx];
			const to = targets[idx + 1];
			if (!from || !to) return;

			const fromY = from.getBoundingClientRect().top + window.scrollY - offset;
			const toY   = to.getBoundingClientRect().top + window.scrollY - offset;
			const p = Math.min(100, Math.max(0, ((window.scrollY - fromY) / (toY - fromY)) * 100));

			// 3 fasi: braccio prima (0→33%), linea orizzontale (33→67%), braccio dopo (67→100%)
			const pBefore = Math.min(100, Math.max(0, p * 3));
			const pLine   = Math.min(100, Math.max(0, (p - 33.33) * 3));
			const pAfter  = Math.min(100, Math.max(0, (p - 66.67) * 3));

			const span = connector.querySelector('span');
			span.style.setProperty('--progress', p.toFixed(2));             // mobile: intera linea
			span.style.setProperty('--progress-before', pBefore.toFixed(2));
			span.style.setProperty('--progress-line', pLine.toFixed(2));
			span.style.setProperty('--progress-after', pAfter.toFixed(2));
		});
	}

	// Throttle rAF: setActive() fa molte letture getBoundingClientRect (reflow).
	// Senza throttle gira ad ogni evento scroll; con rAF al massimo una volta per
	// frame.
	let timelineTicking = false;
	window.addEventListener('scroll', function () {
		if (timelineTicking) return;
		timelineTicking = true;
		requestAnimationFrame(function () {
			setActive();
			timelineTicking = false;
		});
	}, { passive: true });
	setActive();
});
